<template>
    <div class="home-page cg-page">
		<!-- <Header></Header> -->
    <div class="pt20">
    <a class="logo" href="/#/index"><img src="static/images/logo1.png" /></a>
    </div>
		<div class="content mt50">
      <Dialog ref="saveDialog" type="alert" :callback="saveModal" title="Reminder" :btnText="$t('OK')" :cancelText="$t('OK')">
          <div slot="mdBox" >
            {{ msg }}
          </div>
      </Dialog>
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
        msg:'',
      }
    },
    created(){
      let that = this;
      that.msg = that.$route.query.msg;
      this.$nextTick(() => {
        this.$refs.saveDialog.showMaskFun();
      })
    },
    mounted(){
      //this.$refs.saveDialog.showMaskFun();
    },
    methods: {
      saveModal(){
        this.$router.push({path:'/login',query:{}});
      },
    }
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .input{background:none;height:70px;border:none;border-radius: 20px;font-size:38px;font-family:ChevinProBold;padding:0 20px;width:80%;color: #280933;}
  .input-div{margin:30px 40px 10px;}
  .input-div .span{margin: 0 auto 10px;width:70%;}
  .input-item{background:#ebe8f5;border-radius: 20px;height:80px;line-height:80px;width:70%;margin: 0 auto;background-image: linear-gradient(#ffffff,#dce9f2,#9dc0dc,#bbd3e5);
    border: 4px solid #ccc;}
  .input-div div span{font-size:38px;padding-left: 30px;color: #280933;}
  .mt100{margin-top:100px;}
  .opt-a{color: #2d31fa;text-decoration: underline;}
  .btn{line-height:80px;width:100%;color:#fff;width: 230px;}
  .cg-page{background:url(../../static/images/bg.jpg) repeat-y center top #7e00dd;color:#fff}
  .otp-b a{color:#fff}
  .login-content{color:#fff;}
</style>



// WEBPACK FOOTER //
// src/page/error.vue